import { css } from "@emotion/react";

export const styles = {
  stack: css`
    position: relative;
    display: flex;
  `,
  box: css`
    height: 34px;
    width: 34px;
    background-color: white;
    border-radius: 50%;
    z-index: 1;
    top: 50%;
    left: -20px;
    position: absolute;
    transform: translateY(-50%);
  `,
  step: css`
    height: "auto";
    border-radius: 16px;
    background-color: #0045b5;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: center;
    padding: 16px;
    padding-left: 27px;
    flex: 1;
    position: relative;
  `,
  typography: css`
    color: #fff5f5;
    width: 265px;
    font-size: 16px;
    font-weight: 400;
  `
};
